import { CreateTag } from '@ui/tags';
import { GearLinkSection } from './GearLinkSection';
import { OptionFilter } from '@periscopes/general/filters';
import { useTags } from '@hooks';
import { COPY_GENERIC, COPY_SPECIFIC, FULL_ROUTES } from '@sonar-software/sonar-ts-constants';
import React, { memo, useCallback, useMemo, useState } from 'react';
export const TagSelector = memo(({ onChange, value }) => {
    const tags = useTags();
    const [open, setOpen] = useState();
    const sortedTags = useMemo(() => tags.filter((tag) => !tag.autoTagged)
        .map((tag) => ({
        label: tag.name,
        value: tag.id
    })), [tags]);
    const handleOnFinish = useCallback((tagId) => {
        setOpen(false);
        setTimeout(() => setOpen(undefined));
        onChange(tagId);
    }, [onChange]);
    return (React.createElement(GearLinkSection, { route: FULL_ROUTES.TAGS_MANAGE },
        React.createElement(OptionFilter, { onChange: onChange, open: open, options: sortedTags, placeholder: COPY_GENERIC.SELECT(COPY_SPECIFIC.TAG), popupRender: (menu) => React.createElement(React.Fragment, null,
                menu,
                React.createElement(CreateTag, { onFinish: handleOnFinish })), value: value })));
});
